import Delegate from 'ftdomdelegate'
import fastdom from 'fastdom'
import Stickyfill from 'stickyfilljs';

import SearchBar from "../components/search-bar";
import Dom from "../tools/dom";
import Responsive from "../tools/responsive";

export default class HeaderSection {
  constructor(container) {
    var _this43 = this;

    this.element = container;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.lastScrollPosition = -1;
    this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;

    if (this.options['isSticky']) {
      Stickyfill.addOne(this.element.parentNode);
    }

    // Scrolled
    window.addEventListener('scroll', function() {
        let scroll = window.scrollY;
        if (scroll > 0) {
          this.window.document.querySelector('.header').classList.add('header--scrolled')
        } else {
          this.window.document.querySelector('.header').classList.remove('header--scrolled')
        }
    }); 

    // Set up the search bar
    this.searchBar = new SearchBar();

    this._attachListeners();
    this._verifyNavigationOverlap();

    // We set again some CSS variables that are used for some calculations in CSS
    var mainLogo = this.element.querySelector('.header__logoImage--primary');

    if (mainLogo && !mainLogo.complete) {
      mainLogo.addEventListener('load', function () {
        fastdom.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this43.element.clientHeight + 'px');
          document.documentElement.style.setProperty('--header-is-not-transparent', _this43.options['hasTransparentHeader'] ? 0 : 1);
        });
      });
    } else {
      fastdom.measure(function () {
        document.documentElement.style.setProperty('--header-height', _this43.element.clientHeight + 'px');
        document.documentElement.style.setProperty('--header-is-not-transparent', _this43.options['hasTransparentHeader'] ? 0 : 1);
      });
    }
  }

  onUnload() {
    this.element.removeEventListener('mouseleave', this._closeNavigationListener);
    this.element.removeEventListener('mouseenter', this._focusNavigationListener);
    this.element.removeEventListener('focusin', this._focusNavigationListener);

    this.delegateElement.off();

    window.removeEventListener('scroll', this._checkTransparentHeaderListener);
    window.removeEventListener('resize', this._verifyNavigationOverlapListener);

    if (this.options['isSticky']) {
      Stickyfill.removeOne(this.element.parentNode);
    }

    this.searchBar.destroy();
  }
  onSelect() {
    this._checkTransparentHeader();
  }
  onBlockSelect(event) {
    var _this44 = this;

    var listItem = event.target.closest('.horizontalList__item');

    fastdom.mutate(function () {
      event.target.setAttribute('aria-hidden', 'false');

      if (listItem) {
        listItem.classList.add('is-expanded');

        Dom.getSiblings(listItem, '.is-expanded').forEach(function (item) {
          item.classList.remove('is-expanded');
        });
      }

      _this44.element.classList.remove('header--transparent'); // This is needed to make sure everything is visible
    });
  }
  onBlockDeselect(event) {
    var listItem = event.target.closest('.horizontalList__item');

    fastdom.mutate(function () {
      event.target.setAttribute('aria-hidden', 'true');

      if (listItem) {
        listItem.classList.remove('is-expanded');
      }
    });

    this._checkTransparentHeader();
  }
  _attachListeners() {
    this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
    this._closeNavigationListener = this._closeNavigation.bind(this);
    this._focusNavigationListener = this._focusNavigation.bind(this);
    this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);

    this.element.addEventListener('mouseleave', this._closeNavigationListener);

    this.delegateElement.on('mouseenter', '.header__mainNav .horizontalList__item, [aria-haspopup]', this._openMenu.bind(this), true);
    this.delegateElement.on('focusin', '[aria-haspopup]', this._openMenu.bind(this), true);
    this.delegateElement.on('focusout', '[aria-haspopup]', this._closeMenu.bind(this), false);
    this.delegateElement.on('mouseleave', '.DropdownMenu [aria-haspopup]', this._closeMenu.bind(this), true);
    this.delegateElement.on('mouseenter', '.DropdownMenu [aria-haspopup]', this._adjustDropdownPosition.bind(this), true);

    if (this.isTouch) {
      this.delegateElement.on('click', '.header__mainNav [aria-haspopup]', this._handleTouchMenu.bind(this));
    }

    if (this.options['hasTransparentHeader']) {
      this.element.addEventListener('mouseenter', this._focusNavigationListener);
      this.element.addEventListener('focusin', this._focusNavigationListener);
    }

    if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
      window.addEventListener('scroll', this._checkTransparentHeaderListener);
    }

    if (this.options['navigationStyle'] === 'inline' || this.options['navigationStyle'] === 'logoLeft') {
      window.addEventListener('resize', this._verifyNavigationOverlapListener);
    }
  }
  _focusNavigation() {
    var _this45 = this;

    fastdom.mutate(function () {
      if (!_this45.isTouch || Responsive.matchesBreakpoint('desk')) {
        _this45.element.classList.remove('header--transparent');
      }
    });
  }
  _closeNavigation() {
    var _this46 = this;

    fastdom.mutate(function () {
      Dom.nodeListToArray(_this46.element.querySelectorAll('.is-expanded')).forEach(function (item) {
        item.classList.remove('is-expanded');
      });

      Dom.nodeListToArray(_this46.element.querySelectorAll('.header__mainNav [aria-hidden="false"]')).forEach(function (item) {
        item.setAttribute('aria-hidden', 'true');
      });
    });

    if (this.options['hasTransparentHeader']) {
      this._checkTransparentHeader();
    }
  }
  _openMenu(event, target) {
    if (event.type === 'mouseenter' && target !== event.target) {
      return;
    }

    fastdom.mutate(function () {
      target.classList.add('is-expanded');
      Dom.nodeListToArray(target.children, '.header__mainNav [aria-hidden="true"]').forEach(function (item) {
        item.setAttribute('aria-hidden', 'false');
      });

      Dom.getSiblings(target, '.is-expanded').forEach(function (item) {
        item.classList.remove('is-expanded');

        Dom.nodeListToArray(item.children, '.header__mainNav [aria-hidden="false"]').forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
        });
      });
    });
  }
  _closeMenu(event, target) {
    if (event.type === 'mouseleave' && target !== event.target) {
      return;
    }

    fastdom.mutate(function () {
      target.classList.remove('is-expanded');

      Dom.nodeListToArray(target.children, '.header__mainNav [aria-hidden="false"]').forEach(function (item) {
        item.setAttribute('aria-hidden', 'true');
      });
    });
  }
  _adjustDropdownPosition(event, target) {
    var nestedMenus = Dom.nodeListToArray(target.querySelectorAll('.dropdownMenu')),
        shouldOpenLeft = false;

    fastdom.measure(function () {
      var windowWidth = window.innerWidth,
          rightEdge = target.getBoundingClientRect().right;

      nestedMenus.forEach(function (item) {
        if (rightEdge + item.offsetWidth > windowWidth) {
          shouldOpenLeft = true;
        }
      });
    });

    fastdom.mutate(function () {
      if (shouldOpenLeft) {
        nestedMenus.forEach(function (item) {
          item.classList.add('dropdownMenu--reversed');
        });
      } else {
        nestedMenus.forEach(function (item) {
          item.classList.remove('dropdownMenu--reversed');
        });
      }
    });
  }

  /**
   * On touch devices where we display the standard menu (like landscape iPad or Surface) we need to do additional code to properly
   * handle the opening of menu. Especially, what we do is that if an item has a sub-menu, a click does not follow the link but instead open
   * the sub-menu. If this link is clicked a second twice, then the menu is followed
   */

  _handleTouchMenu(event, target) {
    if (!target.classList.contains('is-expanded')) {
      event.preventDefault();
    }
  }
  _verifyNavigationOverlap() {
    var _this47 = this;

    var isOverlapping = false;

    fastdom.measure(function () {
      // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
      var mainTopMenu = _this47.element.querySelector('.header__mainNav');

      if (mainTopMenu) {
        // Get the first element
        var firstNavElementHeight = Dom.outerHeightWithMargin(mainTopMenu.querySelector('.horizontalList__item')),
            mainNavHeight = mainTopMenu.scrollHeight;

        if (mainNavHeight > firstNavElementHeight) {
          isOverlapping = true;
        }
      }
    });

    fastdom.mutate(function () {
      if (isOverlapping) {
        _this47.element.classList.remove('header--' + _this47.options['navigationStyle']);
        _this47.element.classList.add('header--center');
      } else {
        _this47.element.classList.add('header--' + _this47.options['navigationStyle']);
        _this47.element.classList.remove('header--center');
      }

      _this47.element.classList.add('header--initialized');

      fastdom.measure(function () {
        document.documentElement.style.setProperty('--header-height', _this47.element.clientHeight + 'px');
      });
    });
  }

  /**
   * If the header mode is set to "transparent", we have to do extra work to automatically make it with fill colors when the
   * user starts scrolling. For performance we are using fastDOM to do that (which relies of requestAnimationFrame instead of
   * scroll listener)
   */

  _checkTransparentHeader() {
    var _this48 = this;

    if (!this.options['hasTransparentHeader']) {
      return;
    }

    var scrollThreshold = 10;

    fastdom.measure(function () {
      _this48.lastScrollPosition = window.pageYOffset;
    });

    fastdom.mutate(function () {
      if (_this48.lastScrollPosition <= scrollThreshold) {
        _this48.element.classList.add('header--transparent');
      } else {
        _this48.element.classList.remove('header--transparent');
      }
    });
  }
}